// extracted by mini-css-extract-plugin
export default {"heading":"paper_heading__ucmn9"};